export const enum Pages {
  ROOT = '/',
  AUTH_CALLBACK = '/callback',
  NO_PERMISSIONS = '/wait',
  NOT_AUTHORIZED = '/not-authorized',
  NOT_FOUND = 'not-found',
  HOME = 'home',
  UNDISTRIBUTED_PAYMENTS = 'undistributed-payments',
  PAYMENT_IMPORTS = 'payment-imports',
  COUNTERPARTIES = 'counterparties',
  COUNTERPARTY_DETAILS = ':counterpartyId',
  GAS_TARIFFS = 'gas-tariffs',
  RESOURCES = 'resources',
  RESOURCE_DETAILS = ':resourceId',
  INCOMING_PAYMENTS = 'incoming-payments',
  PAYMENT_DETAILS = ':paymentId',
  CONTRACTS = 'contracts',
  ADVANCE_INVOICES = 'advance-invoices',
  EMPLOYEES_PART = 'employees',
  BANK_DETAILS_PART = 'bank-details',
  CHANGE_PASSWORD = 'change-password',
  REPORTS = 'reports',
  REPORTS_LIST = 'reports-list',
  AUDIT = 'audit',
  BI_DASHBOARDS = 'bi-dashboards',
  IMBALANCE_SETTINGS = 'imbalance-settings',
  CAPACITY_SETTINGS = 'capacity-settings',
  PON_GAS_PRICE_SETTINGS = 'pon-gas-price-settings',
  PSO_FORMULA_PARAMETERS = 'pso-formula-parameters',
  MARKET_GAS_PRICE_TYPES = 'market-gas-price-types',
  PSO_FORMULA_VARIABLES = 'pso-formula-variables',
}
